import React from "react";
import { Field, ErrorMessage } from "formik";
import TextError from "./TextError";
import "./Select.styles.scss";

function Select(props) {
  const { label, name, options, ...rest } = props;
  return (
    <div className="select_form_control">
      <label className="" htmlFor={name}>
        {label}
      </label>
      <Field
        as="select"
        id={name}
        name={name}
        {...rest}
        className="select_formik white"
      >
        {options.map((option) => {
          return (
            <option
              key={option.value}
              className="select_formik_option"
              value={option.value}
            >
              {option.key}
            </option>
          );
        })}
      </Field>
      <ErrorMessage component={TextError} name={name} />
    </div>
  );
}

export default Select;
